@if (scopedItem()) {
  <section
    aria-label="Item comments"
    class="border-t border-border px-8 py-6"
    [hidden]="!visible()"
    [attr.inert]="visible() ? null : ''"
  >
    @if (visible()) {
      <div class="flex items-center justify-between">
        @if (activityAvailable()) {
          <div role="tablist" aria-label="Item footer" class="flex">
            <button
              #commentsTab
              type="button"
              role="tab"
              [id]="footerId + '-comments-tab'"
              [attr.aria-controls]="footerId + '-comments'"
              [attr.tabindex]="footerTab() === 'comments' ? 0 : -1"
              [attr.aria-selected]="footerTab() === 'comments'"
              class="border-b-2 px-8 py-4 text-base leading-10"
              [class.font-semibold]="footerTab() === 'comments'"
              [class.border-primary-600]="footerTab() === 'comments'"
              [class.border-transparent]="footerTab() !== 'comments'"
              (click)="selectFooterTab('comments')"
              (keydown)="handleFooterKey($event, 'comments')"
            >
              Comments
            </button>
            <button
              #activityTab
              type="button"
              role="tab"
              [id]="footerId + '-activity-tab'"
              [attr.aria-controls]="footerId + '-activity'"
              [attr.tabindex]="footerTab() === 'activity' ? 0 : -1"
              [attr.aria-selected]="footerTab() === 'activity'"
              class="border-b-2 px-8 py-4 text-base leading-10"
              [class.font-semibold]="footerTab() === 'activity'"
              [class.border-primary-600]="footerTab() === 'activity'"
              [class.border-transparent]="footerTab() !== 'activity'"
              (click)="selectFooterTab('activity')"
              (keydown)="handleFooterKey($event, 'activity')"
            >
              Activity
            </button>
          </div>
        } @else {
          <h2 class="text-base leading-10 font-medium">Comments</h2>
        }
        <div
          #openCommentsControl
          [hidden]="footerTab() !== 'comments'"
          [attr.inert]="footerTab() === 'comments' ? null : ''"
        >
          <button type="button" aria-label="Open Comments" class="text-sm text-primary-600" (click)="showComments()">
            Open Comments
          </button>
        </div>
      </div>
      <div
        #commentsPanel
        [id]="footerId + '-comments'"
        [attr.role]="activityAvailable() ? 'tabpanel' : null"
        [attr.aria-labelledby]="activityAvailable() ? footerId + '-comments-tab' : null"
        [hidden]="footerTab() !== 'comments'"
        [attr.inert]="footerTab() === 'comments' ? null : ''"
      >
        <div class="max-h-60 overflow-y-auto py-4">
          @for (comment of comments(); track comment.id) {
            <article class="flex gap-4 py-2 text-sm">
              <span
                aria-hidden="true"
                class="flex size-16 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-200"
              >
                @if (comment.avatar) {
                  <img [src]="comment.avatar" alt="" class="size-full object-cover" />
                } @else {
                  {{ comment.initials }}
                }
              </span>
              <div class="min-w-0 grow">
                <div class="flex gap-4">
                  <strong>{{ comment.author }}</strong
                  ><time class="text-subdued">{{ comment.createdAt | timeAgo }}</time>
                </div>
                <div [innerHTML]="comment.text | safeHtml"></div>
              </div>
            </article>
          } @empty {
            <p class="text-sm text-subdued">Add an item comment to coordinate this work.</p>
          }
        </div>
        <div class="flex items-end gap-4">
          <textarea
            aria-label="Quick item comment"
            [placeholder]="placeholder()"
            [formControl]="draft"
            rows="1"
            maxlength="4000"
            [readOnly]="submitting()"
            class="min-w-0 grow rounded border border-border p-4"
          ></textarea>
          <button
            type="button"
            aria-label="Send item comment"
            [disabled]="submitting()"
            class="rounded px-4 py-2 text-primary-600 disabled:opacity-50"
            (click)="send()"
          >
            Send item comment
          </button>
        </div>
      </div>
    }
    <div
      #activityPanel
      class="max-h-60 overflow-y-auto"
      [id]="footerId + '-activity'"
      role="tabpanel"
      [attr.aria-labelledby]="footerId + '-activity-tab'"
      [hidden]="footerTab() !== 'activity'"
      [attr.inert]="footerTab() === 'activity' ? null : ''"
    >
      @if (activityVisited() && activityAvailable()) {
        <ng-container *ngComponentOutlet="activityComponent(); inputs: activityInputs()" />
      }
    </div>
  </section>
}
